/* eslint-disable @angular-eslint/directive-selector */
import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[autofocus]',
})
export class AutofocusDirective implements OnInit {
    private _autofocus?: boolean;

    @Input() set autofocus(condition: any) {
        this._autofocus = condition !== false && condition !== 'false';
    }

    constructor(private el: ElementRef) {}

    ngOnInit(): void {
        if (this._autofocus || typeof this._autofocus === 'undefined') {
            setTimeout(() => {
                this.el.nativeElement.focus();
            });
        }
    }
}
